import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { registerStore } from "./redux/storeRegistry";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/theme.scss";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { PicProvider } from "./context/PicProvider";
import { SocketContextProvider } from "./context/SocketContext";
import { createTheme, ThemeProvider } from "@mui/material";
const root = ReactDOM.createRoot(document.getElementById("root"));
// Make the store reachable from non-React modules (axios interceptor) without
// creating a circular import. Must run before anything can trigger a logout.
registerStore(store);
const persistor = persistStore(store);
export { persistor };

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#006AFF",
    },
    text: {
      primary: "#16161D",
    },
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "6px !important",
          input: {
            "&::placeholder": {
              color: "#595c5f",
              opacity: 1,
              fontWeight: 350,
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(228, 228, 228, 0.6)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(228, 228, 228, 0.6)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(4, 120, 53, 0.2)",
              // boxShadow: "0 0 0 0.25rem rgba(0, 106, 255, 0.25)",
              borderWidth: "1px",
            },
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: "#16161D",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          "& .MuiTabs-scrollButtons": {
            display: "inline-flex",
          },
        },
      },
    },
  },
});

root.render(
  // <React.StrictMode>
  <ThemeProvider theme={muiTheme}>
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          <PicProvider>
            <SocketContextProvider>
              <App />
            </SocketContextProvider>
          </PicProvider>
        </PersistGate>
        <ToastContainer autoClose={1800} />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
